import axios from "axios";

import {BASE_URL, LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE } from "constants";

const loginRequest = () => {
    return{
        type:LOGIN_REQUEST
    }
}

const loginSuccess = (payload) => {
    localStorage.setItem("subjectId",payload.subjectId);
    return{
        type:LOGIN_SUCCESS,
        payload,
    }
}

const loginFailure = () => {
    return{
        type:LOGIN_FAILURE
    }
}

export const login = (redirectFunc) => async (dispatch) => {
    try{
        dispatch(loginRequest());
        const response = await axios.get(`${BASE_URL}/navigation/navigation-information`,{
            headers: {
            Authorization: 'Bearer ' +  localStorage.getItem("token")},
        });
        dispatch(loginSuccess(response.data));
    }catch(e){
        localStorage.clear();
        dispatch(loginFailure());
    }
    redirectFunc();
}